import o from"./index.module.scss.js";const s=o;export{s as CircularProgressbarTheme};
//# sourceMappingURL=index.js.map
